import { cmsLoadCopy, cmsLoadFlowCopy } from '@actions/cms.action';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {CmsKeys, ContentPageKeys, FeaturePageKeys} from '@constants/cms.constants';
import { Store } from '@ngrx/store';
import { CoreState } from '@reducers/index';
import { selectIsCultureValidAndEnabled } from '@selectors/router.selector';
import { pathPartToCmsCopyName } from '@utils/data-utils';
import { filter, map, Observable } from 'rxjs';

export const cmsDataGuard = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const store = inject<Store<CoreState>>(Store);

  return store.select(selectIsCultureValidAndEnabled).pipe(
    filter((isValid) => isValid),
    map(() => {
      getCmsDataFromStoreOrApi(route, store);

      return true;
    }),
  );
};

const getCmsDataFromStoreOrApi = (
  route: ActivatedRouteSnapshot,
  store: Store,
): void => {
  if (route.url.length <= 0) {
    return;
  }
  route.url.forEach((urlPart) => {
    store.dispatch(
      cmsLoadCopy({
        key: pathPartToCmsCopyName(urlPart.path),
      }),
    );
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  route.data?.additionalCmsKeys?.forEach((additionalCmsKey: CmsKeys) => {
    store.dispatch(
      cmsLoadCopy({key: additionalCmsKey})
    )
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  route.data?.additionalCmsFlowKeys?.forEach((additionalCmsFlowKey: CmsKeys) => {
    store.dispatch(
      cmsLoadFlowCopy({key: additionalCmsFlowKey})
    )
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  route.data?.umbracoContentPages?.forEach((contentPageKey: ContentPageKeys) => {
    store.dispatch(
      cmsLoadFlowCopy({contentPageKey})
    )
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  route.data?.umbracoFeatures?.forEach((featurePageKey: FeaturePageKeys) => {
    store.dispatch(
      cmsLoadFlowCopy({featurePageKey})
    )
  })
};
